import firebase from 'firebase'
import Vue from 'vue'
import Vuex from 'vuex'
// import { mapGetters, stateAfter } from 'vuex'
import createLogger from 'vuex/dist/logger'
// import { objectsToArrays, haversine } from './../services/selectors';
// import * as R from 'ramda';
import moment, { now } from 'moment'
// import Rx from 'rxjs/Rx'
// import { Observable } from 'rxjs/Observable'
Vue.use(Vuex)
import router from '../router'
// import axios from 'axios';

const logger = createLogger({
    collapsed: false, // auto-expand logged mutations
    filter(mutation, stateBefore, stateAfter) {
        // returns `true` if a mutation should be logged
        // `mutation` is a `{ type, payload }`
        return mutation.type !== "aBlacklistedMutation"
    },
    transformer(state) {
        // transform the state before logging it.
        // for example return only a specific sub-tree
        return state.subTree
    },
    mutationTransformer(mutation) {
        // mutations are logged in the format of `{ type, payload }`
        // we can format it any way we want.
        return mutation.type
    },
    logger: console, // implementation of the `console` API, default `console`
})

const state = {  
 
    person: null,
    profile:null,
    location: null,
    business: null,
    companies:null,
    templateconfig:null, 
    toastmessage: null,
    fcmToken: "",
    sysadmin:false,
    adminrights: null,   
    alladminrights:null,     
    customeraccounts: null,    
    last5soldremedials:null,
    tx: null,
    bannermessage:null,
    newversionavailable:false,
    config:null,
    addtohomescreen:null,
    last10messages:null,
    serversidemessages:null
}

const getters = {    
    bannermessage: state => state.bannermessage,  
    newversionavailable:state => state.newversionavailable,       
    routetitle:state=>state.route.meta?state.route.meta.title:"",    
    route:state=>state.route, 
    business: state => state.business,
    companies: state => state.companies,    
    templateconfig: state => state.templateconfig,    
    
    person: state => state.person,
    profile:state => state.profile,
  
    remedialtemplate: state => '<div>{{remedial}}</div>', 
    sysadmin: state => state.sysadmin,
    adminrights: state => state.adminrights,
    alladminrights: state => state.alladminrights,
    location: state => state.location, 
    fcmToken: state => state.fcmToken, 

    customeraccounts: state => state.customeraccounts,
    tx: state => state.tx,    
    last5soldremedials: state => state.last5soldremedials,    
    config:state=>state.config,
    addtohomescreen:state=>state.addtohomescreen,
    last10messages:state=>state.last10messages,
    serversidemessages:state=>state.serversidemessages
}

const mutations = {
    //reducers 
    
    setConfig(state, config) {
        state.config = config
    },    
    setNewVersionAvailable(state, newversionavailable) {
        state.newversionavailable = newversionavailable
    }, 
    
    addToLast10Messages(state, message) {
        state.last10messages = state.last10messages || []
        if(state.last10messages.length==10)
            state.last10messages.pop()

        state.last10messages.unshift(message)
    }, 

    setBannerMessage(state, bannermessage) {
       state.bannermessage = bannermessage        
    }, 
    setfcmToken(state, fcmToken) {
        state.fcmToken = fcmToken
    },
    setToastMessage(state, toastmessage) {        
        state.toastmessage = toastmessage
    },
    setPerson(state, person) {
        state.person = person
    },
    setProfile(state, profile) {
        state.profile = profile
    },
    setServerSideMessages(state, serversidemessages) {
        state.serversidemessages = serversidemessages
    },
    setSysAdmin(state, sysadmin) {
        state.sysadmin = sysadmin
    },
    setAllBusinessRights(state, alladminrights) {
        state.alladminrights = alladminrights
    },
    setRights(state, adminrights) {
        state.adminrights = adminrights
    }, 
    
   
    last10AccountTransactions(state, tx) {
        state.tx = tx
    },
    searchForCustomerAccounts(state, customeraccounts) {
        state.customeraccounts = customeraccounts
    },
    clearbasedeals(state) {
        state.basedeals = []
    },
    setLocation(state, location) {
        state.location = location
    },
    enableBusinessPositions(state){
        let p = { ...state.business, positions: {items:{},title:""}}        
        state.business = p
    },
    setBusiness(state, business) {
        state.business = business;
    },
    setCompanies(state, companies) {
        state.companies = companies;
    },
    setTemplateConfig(state, templateconfig) {
        state.templateconfig = templateconfig;
    },
    
    logOut(state) {
        state.person = null;
        state.profile=null;
      
        state.sysadmin = false
        state.adminrights =null;
        state.alladminrights=null;          
        state.last5soldremedials = null;
        state.addtohomescreen = null;
        state.last10messages=null;
        state.serversidemessages=null
    },
   
    setLast5SoldRemedials(state, last5soldremedials) {
        state.last5soldremedials = last5soldremedials;
    },    
    enableAddToHomeScreen(state, addtohomescreen) {
        state.addtohomescreen = addtohomescreen;
    }     

}

let dealsWatcher
let customerRemedialsWatcher
let customersRemedialsWatcher
let businessWatcher
let deferredPrompt//add to home screen prompt
let timer

const actions = {
    //context is the store  
    // route({commit,state},route){
    //     this.$router.push({name: route.name, params: { id: route.id }})
    // },   
    
    setBannerMessage({ commit, state,dispatch }, bannermessage) {                
        
        //dispatch('setBannerMessage',{type:'error',message:"Payment window could not be created."})  
        //dispatch('setToastMessage', {type: 'info', message: `Adding to home screen.`, title: 'Add Home' })
        if(timer)
            clearInterval(timer)

        commit('setBannerMessage',bannermessage)         
        timer = setTimeout(()=>{commit('setBannerMessage',null)}, 5000);               

        if(bannermessage)
            commit('addToLast10Messages',bannermessage)

    },

    setToastMessage({ commit, state,dispatch }, toastmessage) {
        // commit('setToastMessage', toastmessage)
        dispatch('setBannerMessage',toastmessage) 
        // if(toastmessage && toastmessage.message)
        //     commit('addToLast10Messages',toastmessage.message)
    },

    addToHomeScreen({ commit, state,dispatch }){
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice
            .then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                dispatch('setToastMessage', { type: 'info', message: `Adding to home screen.`, title: 'Add Home' })
                console.log('User accepted the A2HS prompt');
            } else {
                dispatch('setToastMessage', { type: 'warning', message: `Not adding to home`, title: 'Add Home' })                
            }
            deferredPrompt=null
            commit('enableAddToHomeScreen', null)            
        });
    }, 

    enableBusinessPositions({ commit, state,dispatch }){
        commit('enableBusinessPositions')      
    },    
    
    
    getHelpPage({ commit, state,dispatch },helppage){
        return new Promise((resolve)=>{
            if(!helppage)            
                resolve(null)                            
                
            firebase.database().ref(`/help/pages/${helppage}`)
            .on('value', (snapshot) => {
                var page = snapshot.val()
                if (page) {                    
                    resolve(page)
                }
                else
                {
                    resolve(null)
                }
            })        

        })   
    },
    createGuidKey(){
        return new Promise((resolve,reject)=>{
            let key = firebase.database().ref().push().key
            if(key)
                resolve(key)
            else
                reject("No Key")
        })        
    },

  
    

    async setupUser({ commit, state,dispatch },user){        
       
        if (user) {
            dispatch('setToastMessage', { type: 'info', message: `Your login details.`, title: 'Page refreshed' })
            // User is signed in.            
            var mapUser = {
                uid: user.uid,     // << Just the bits we need
                id: user.uid,
                email: user.email || "",
                displayName: user.displayName || "",
                name: user.displayName || "",
                token: user.qa || "",
                photo: user.photoURL
            }                
            commit('setPerson', mapUser)

            //only do this once but monitor all the time.
            firebase.database().ref(`/users/profile/${mapUser.uid}`)
            .on('value', (snapshot) => {
                var profile = snapshot.val()
                if (profile) {
                    commit('setProfile', profile)
                }
            })            

            firebase.database().ref(`/notifications/standardserverside/${mapUser.uid}`).set(null).then(() => {
                //only do this once but monitor all the time.
                firebase.database().ref(`/notifications/standardserverside/${mapUser.uid}`)
                .on('value', (snapshot) => {
                    var sm = snapshot.val()
                    if (sm) {
                        dispatch('setToastMessage',{ type: sm.type, message: sm.message, title: sm.from })                         
                    }
                })  
            })
                    

            commit('setAllBusinessRights', null)            
            commit('setSysAdmin', null)

            await firebase.database().ref(`/groups/pers/${mapUser.uid}/administration/referencedata/businesses`)
                .on('value', (snapshot) => {
                    var adminrights = snapshot.val()
                    if (adminrights) {
                        commit('setAllBusinessRights', adminrights)              
                }
            });

            await firebase.database().ref(`/groups/systemadmin/pers/${mapUser.uid}`)
            .once('value', (snapshot) => {
                var sysadmin = snapshot.val()                                         
                if(sysadmin)                  
                    commit('setSysAdmin', true)
                });                   

            dispatch('setLoggedInAuths');

        } else {
            // No user is signed in.
            dispatch('setToastMessage', { type: 'info', message: `Login at any time.`, title: 'Currently logged Out' })
        }
    },
    
    //setup the logged in users Auths for the application.      
    setLoggedInAuths({ commit, state,dispatch }){           
        
        if(!state.person && !state.business)
            return        
                
        commit('setRights', null)
        let ad = state.alladminrights?state.alladminrights[state.business.id]:null 
        commit('setRights', ad)
        
        if(state.sysadmin)
            commit('setRights', {allbusinessremedials:true,default:false,name:state.business.name,read:true,write:true} )
      
    },     
  
    addImageToEntityReduceSize({ commit, state,dispatch }, upload) {
        return new Promise((resolve, reject) => { 
            if(!upload.id)
            {
                dispatch('setToastMessage', { type: 'error', message: `Missing Entity Identifier`, title: upload.location })
                reject("Missing Entity Identifier")
            }

            if(!upload.location)
            {
                dispatch('setToastMessage', { type: 'error', message: `Missing Entity Location`, title: 'Image upload'})
                reject("Missing Entity Location")
            } 

            // Create a reference to the file whose metadata we want to change
            var storageRef = firebase.storage().ref();
            // Create a reference to 'mountains.jpg' need business id to prevent writes if not authored.            
            var newimage = storageRef.child(`safetodelete/tempimages/converttothumbnail/business/${upload.business_id}/${upload.file.name}`);
            var newMetadata = {
                customMetadata: {
                    'id': upload.id,
                    'business_id':upload.business_id,//needed as this is checked against the users rights access.
                    'location': upload.location,
                    'linkedbusinesslocation': upload.linkedbusinesslocation,
                    'push':upload.push
                }
            }
            let uploadtask = newimage.put(upload.file,newMetadata)            
            
            // Register three observers:
            // 1. 'state_changed' observer, called any time the state changes
            // 2. Error observer, called on failure
            // 3. Completion observer, called on successful completion
            uploadtask.on('state_changed', function(snapshot){
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                console.log('Upload is ' + progress + '% done');                
                dispatch('setBannerMessage',{message:'Upload is ' + progress + '% done'})
                switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log('Upload is paused');
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log('Upload is running');
                        break;
                }

            }, function(error) {
                // Handle unsuccessful uploads
                console.log(error)                
                dispatch('setToastMessage', { type: 'error', message: `Error ${error.code}. Please ensure you are uploading images only or try logging on again, if the problem persists contact your admin.`, title: 'Image Storage' })                
                reject(error)
            }, function() {
                // Handle successful uploads on complete
                // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                // console.log('Upload is done, here is your url');
                //cannont use this url as it is the full sized image not the processed image.
                // var downloadURL = uploadtask.snapshot.downloadURL;
                // console.log(downloadURL)                                
                dispatch('setBannerMessage',{message:'Complete! please press the refresh button at the top, you may need to do this a few times.'})
                resolve(true)
                
            })       
            
            
        })
    
    },  
     

    setfcmToken(context, fcmToken) {
        context.commit('setfcmToken', fcmToken)
    },                 

    //get the staff for the business selected
    getBusinessStaff({commit, state,dispatch},businessid){
        return new Promise((resolve)=>{
            firebase.database().ref(`/groups/businesses/${businessid}/staff`)
            .on('value', (snapshot) => {                
                var businessestaff = snapshot.val()
                resolve(businessestaff)
            })      
        })
    },
    //get a simple fullbusiness but do not save to state.
    fullbusiness({ commit, state,dispatch },id){
        return new Promise((resolve)=>{            
            dispatch('setBannerMessage',{type:'info',message:'Getting Businesses details please wait'})  
            firebase.database().ref(id!==undefined?`web/businesses/${id}`:`web/businesses`).once('value')
            .then(snapshot=>{                
                resolve(snapshot.val())
            })
        })                
    },

    businessremedials({ commit, state,dispatch },{id,assigned}){
        return new Promise((resolve)=>{      
            dispatch('setBannerMessage',{type:'info',message:'Getting Businesses remedials please wait'})      
            firebase.database().ref(`/remedials/businesses/${id}/processingremedials`)
            .once('value', (snapshot) => {
                dispatch('setBannerMessage',{type:'info',message:'Businesses remedials Loaded....'})      
                var businessremedials = snapshot.val()
                resolve(businessremedials)                                    
            }) 
        })
    },

    fullremedial({ commit, state,dispatch },{id,business}){
        return new Promise((resolve)=>{            
            dispatch('setBannerMessage',{type:'info',message:'Getting remedial details please wait...'})  
            firebase.database().ref(`remedials/businesses/${business.id}/processingremedials/${id}`).once('value')
            .then(snapshot=>{        
                let remedial = snapshot.val()        
                resolve({business,...remedial})
                dispatch('setBannerMessage',{type:'info',message:'Remedial loaded...'}) 
            })
        })                             
    },
    
    //get businesses I can lodge remedials with.
    lodgewithbusinesses({ commit, state,dispatch },{business}){
        if(!business)
            return
        return new Promise((resolve)=>{                           
            dispatch('setBannerMessage',{type:'info',message:'Getting lodged Businesses please wait'})  
            firebase.database().ref(`web/references/businesses/${business.id}/lodgebusinesses`).once('value')
            .then(snapshot=>{                                
                resolve(snapshot.val())
            })
        })                  
    },
    
    linkedbusiness({ commit, state,dispatch },{business}){
        if(!business)
            return
        return new Promise((resolve)=>{                           
            dispatch('setBannerMessage',{type:'info',message:'Getting Linked Businesses please wait'})  
            firebase.database().ref(`web/references/businesses/${business.id}/linkedbusinesses`).once('value')
            .then(snapshot=>{                                
                resolve(snapshot.val())
            })
        })                
    },

    getbusinessgroupusers({ commit, state,dispatch },{business}){
        if(!business)
            return
        return new Promise((resolve)=>{                           
            dispatch('setBannerMessage',{type:'info',message:'Getting users'})  
            firebase.database().ref(`groups/businesses/${business.id}/staff`).once('value')
            .then(snapshot=>{                                
                resolve(snapshot.val())
            })
        })                
    },

    remedialCommands({ commit, state,dispatch }, {command,remedial,meta,business}) {            
        
        // var remedialdirectcommands = firebase.functions().httpsCallable('remedialdirectcommands');
        // remedialdirectcommands({text: "hey this is cooooooo"}).then(function(result) {
        //         // Read result of the Cloud Function.
        //         console.log(result)        
        // }).catch(function(error) {
        //     // Getting the Error details.
        //     var code = error.code;
        //     var message = error.message;
        //     var details = error.details;
        //     console.log(error)
        // });


        //let key = firebase.database().ref().push().key
        /*
            "jobnumber": 323247,
            "Received": 42482,
            "Address": "Lot 53, 18 Malbec Place, Huapai",
            "issue": "Remove object under carpet in main bedroom",
            "Installer": "George",
            "CustomerName": "Sharon Walton",
            "CustomerPhone": "021 356 009",
            "CustomerEmail": "",
            "GBContact": "Dean Hodgson",
            "Status": "unknown",
            "Notes": "",
            "Advised": "",
            "Billed": "",
            "Chargeable": ""
        */
      
        remedial.customer = {
            name:remedial.CustomerName||null,
            phone1:remedial.CustomerPhone||null,
            email:remedial.CustomerEmail||null
        }          

        dispatch('setToastMessage', { type: 'info', message:"Sending request to update remedial in the cloud", title: 'PROCESSING' })
        firebase.database().ref(`/remedialcommands/`).push({command,remedial,business:business,meta:meta||null}).then(() => {

        })
    },
    
    alertBusinessAboutRemedial({commit,state,dispatch}, customerremedial) {
        
        firebase.database().ref(`/commands/${firebase.auth().currentUser.uid}`).push({
            command: 'alertBusinessAboutRemedial',
            remedial: { id: customerremedial.id, business: customerremedial.remedial.business},
            person: { id: state.person.id, name: state.person.name}
        }).then(() => {
            dispatch('setToastMessage', { type: 'info', message: `Sending alert please be considerate about sending to many alerts`, title: 'Alert' })
        }).catch(ex => {
            console.log(ex);
        });

    },

    alertBusinessAboutYourLocation({commit,state,dispatch}, customerremedial) {
        
        firebase.database().ref(`/commands/${firebase.auth().currentUser.uid}`).push({
            command: 'alertBusinessAboutYourLocation',
            remedial: { id: customerremedial.id, business: customerremedial.remedial.business},
            person: { id: state.person.id, name: state.person.name},
            location:state.location
        }).then(() => {
            dispatch('setToastMessage', { type: 'info', message: `Sending alert about your location`, title: 'Alert' })
        }).catch(ex => {
            console.log(ex);
        });

    },   
    
    setBusiness({commit,state,dispatch}, id) {
        return new Promise((resolve)=>{
            if(businessWatcher)
                businessWatcher.off()

            businessWatcher = firebase.database().ref(`web/businesses/${id}`)
            businessWatcher.on('value', (snapshot) => {
                var obBusiness = snapshot.val();
                if (obBusiness) {                    

                    var business = { id: id, ...obBusiness}//remap business. 
                    business.favi = `${state.config.globals.publicPath}${business.assets}/img/icons/android-chrome-256x256.png`
                    commit('setBusiness', business);  
                    dispatch('setBannerMessage',{type:'info',message:`Shop has been set to ${business.name}`})
                    resolve(business)                      
                }
            }, (error) => {                              
                resolve(null)   
                dispatch('setBannerMessage',{type:'error',message:'Cannot set business, possibly Incorrect Locator used, please correct.'})             
            })
        })
    },
    
    changeBusiness: async ({ commit, state,dispatch },id) => {           
            if(!id || id===undefined)
            {
                dispatch('setBannerMessage',{type:'error',message:'Missing the business id.'})      
                return 
            }
         
            dispatch('setBannerMessage',{type:'info',message:'Attempting to change business, clearing your tokens.'})  
            let result = await dispatch('clearFCMTokens')
            
            dispatch('setBannerMessage',{type:'info',message:'Attempting to now set the business, tokens cleared.'})  
           
            let business = await dispatch('setBusiness', id) 
            
            dispatch('setBannerMessage',{type:'info',message:'Dispatching deals watcher for the business.'})  
            // dispatch('initiateDealsWatcher', business.id) 

            dispatch('setBannerMessage',{type:'info',message:'Setting items relevant to the business and the person.'})  
            dispatch('setLoggedInAuths')            

    },

    async setBusinessReferences({ commit, state,dispatch },id){ 
      
            await firebase.database().ref(`/web/references/businesses/${id}/companies`)
            .once('value', (snapshot) => {
                var companies = snapshot.val()
                commit('setCompanies', companies)                
            })        

            let statusessnapshot = await firebase.database().ref(`/web/templates/remedial/statuscodes/common`)
            .once('value', (snapshot) => {
                var sn = snapshot.val()                  
                return sn
            })  
                        
            let newremedialtemplate = await firebase.database().ref(`/web/templates/remedial/newremedial`)
            .once('value')
            .then((snapshot)=>{
                return snapshot.val()
            })  

            let templateConfig = {}
            templateConfig['statuses'] = statusessnapshot.val()
            templateConfig['newremedialtemplate'] = newremedialtemplate
            

            commit('setTemplateConfig', templateConfig)             

    }, 

    setConfig({ commit, state,dispatch },globals){ 
        return new Promise(resolve=>{
            
            // return firebase.database().ref(`/web/config/default`)
            // .once('value', (snapshot) => {
            //     var config = snapshot.val()
                let config =  {}                
                config.globals = globals
                if (config) {
                    commit('setConfig', config)
                }
                // resolve(config)
                resolve(true)
            // }).catch(()=>{
            //     resolve(null)
            // })        

        })      
        
    },  
    
    setLocation({ commit, state }, location) {
        commit('setLocation', location)
    },

    selfgroupcommands({dispatch},request) {
   
        firebase.database().ref(`/selfgroupcommands`).push({
            command: request.command,
            business: { id: request.business.id}
        }).then(() => {
            dispatch('setToastMessage', { type: 'info', message: `Requested made to change your rights.`, title: 'Rights' })
        }).catch(ex => {
        });
    },

    groupCommands({ commit, state,dispatch },request) {
   
        firebase.database().ref(`/groupcommands`).push({
            command: request.command,
            business: { id: state.business.id, name: state.business.name},
            rights: request.rights || null,
            person:{
                token:request.token ||null,
                id:request.id||null,
                knownAs:request.knownAs
            }
        }).then(() => {
            dispatch('setToastMessage', { type: 'info', message: `Add/Change or Remove user`, title: 'Rights' })
        }).catch(ex => {
        });
    },
    
    businesslinkcommands({ commit, state,dispatch },{command,linkedbusiness,business,meta}) {

        firebase.database().ref(`/businesslinkcommands`).push({
            command: command,
            linkedbusiness:linkedbusiness,
            business: business || { 
                id: state.business.id
            },
            meta:meta||null   
        }).then(() => {
            let c = command
            switch (command) {                
                case 'removeLinkedBusiness': 
                    c= 'Removing Business Link'                  
                    break;                                       
                case 'toggleDirectRemedialCreation': 
                    c= 'Changing Direct Remedial rights'                  
                    break;  
                case 'addLinkToBusiness': 
                    c= 'Linking business'                  
                    break;  
                default:
                    break;
            }
            dispatch('setToastMessage', { type: 'info', message: `Business Link "${c}" command sent`, title: 'Business Links' })
            return
        });
    },

    businesscommands({ commit, state,dispatch },request) {

        firebase.database().ref(`/businesscommands`).push({
            command: request.command,
            business: request.business || { 
                id: state.business.id, 
                image:state.business.image||null,
                latitude:state.business.latitude||null,
                longitude:state.business.longitude||null,
                name: state.business.name||null, 
                assets: state.business.assets||null,
                shortname: state.business.shortname||null, 
                subdomain: state.business.subdomain||null, 
                email: state.business.email||null, 
                website: state.business.website||null, 
                phone: state.business.phone || null, 
                phone2: state.business.phone2 || null
            },           
            meta:request.meta||null   
        }).then(() => {
            let c = request.command
            switch (request.command) {
                
                case 'changeBusinessStatus': 
                    c= 'Changing Status'                  
                    break;
                case 'createBusiness': 
                    c= 'Creating new Business'                  
                    break;   
                case 'removeBusiness': 
                    c= 'Removing Business'                  
                    break;  
                case 'saveBusinessConfig': 
                    c= 'Saving Sysadmin Config settings'                  
                    break;                       
                case 'saveBusinessStandardAdmin': 
                    c= 'Saving Business common details'                  
                    break;                           
                default:
                    break;
            }
            dispatch('setToastMessage', { type: 'info', message: `Business "${c}" command sent`, title: 'Business' })
            return
        });
    },
    updateBusinessLocation({ commit, state,dispatch }, {id}) {
        navigator.geolocation.getCurrentPosition(
            position => {
                var coords = { latitude: position.coords.latitude, longitude: position.coords.longitude };
                commit('setLocation',{ coords: coords, latitude: position.coords.latitude, longitude: position.coords.longitude }) 
                
                firebase.database().ref('web/businesses').child(id)
                .update({
                    longitude: coords.longitude,
                    latitude: coords.latitude
                }, (result) => {                    
                    let business = {...state.business}
                    business.latitude = coords.latitude
                    business.longitude = coords.longitude
                    commit('setBusiness', business);
                }).then(() => {
                    dispatch('setToastMessage', { type: 'info', message: `Saving business Location, you will need to refresh.`, title: 'Location' })                    
                });
            },error=>{
                dispatch('setToastMessage', { type: 'error', message: `Location not available`, title: 'Location' })
            },
            {
                enableHighAccuracy: false,
                useSignificantChanges: true,
                timeout: 3600000,
                maximumAge: 1800000,
                desiredAccuracy: 0, frequency: 1
        })        
    },
    logUserInFacebook({ commit, state,dispatch }) {
        var provider = new firebase.auth.FacebookAuthProvider();
        provider.addScope("email");
        firebase
            .auth()
            .signInWithPopup(provider)
            .then(result => {
                dispatch('setToastMessage', { type: 'info', message: `${result.user.displayName} you are logged in with your Facebook account`, title: 'Facebook Login' })
            });
    },
    
    logUserInEmail({ commit, state,dispatch },email) {

        var actionCodeSettings = {
            // URL you want to redirect back to. The domain (www.example.com) for this
            // URL must be whitelisted in the Firebase Console.
            url: 'http://remedials.fibi.localhost:8080',
            // This must be true.
            handleCodeInApp: true
          };


        firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings)
        .then(function() {
            // The link was successfully sent. Inform the user.
            // Save the email locally so you don't need to ask the user for it again
            // if they open the link on the same device.
            dispatch('setToastMessage', { type: 'info', message: `Please check your email to login` })
            // window.localStorage.setItem('emailForSignIn', email);
        })
        .catch(function(error) {
            dispatch('setToastMessage', { type: 'error', message: error })
        });

        // var provider = new firebase.auth.GoogleAuthProvider();
        // provider.addScope("profile");
        // provider.addScope("email");
        // firebase.auth().signInWithPopup(provider).then(result => {
        //     dispatch('setToastMessage', { type: 'info', message: `${result.user.displayName} you are logged in with your Google account`, title: 'Google Login' })
        // },(error)=>{
        //     dispatch('setBannerMessage',{type:'error',message:error}) 
        // });
    },
    logUserInGoogle({ commit, state,dispatch }) {
        var provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope("profile");
        provider.addScope("email");
        firebase.auth().signInWithPopup(provider).then(result => {
            dispatch('setToastMessage', { type: 'info', message: `${result.user.displayName} you are logged in with your Google account`, title: 'Google Login' })
        },(error)=>{
            dispatch('setBannerMessage',{type:'error',message:error}) 
        });
    },
    logout: ({ commit, state,dispatch }) => {
        
        dispatch('clearFCMTokens').then(()=>{
            firebase.auth().signOut().then(() => {
                commit('logOut')
            });
        })        
        
    },    
    clearFCMTokens: async ({ commit, state }) => {
        
        //clear any business tokens
        if(state.adminrights && state.adminrights.write)
        {   //check if the user is an admin first before clearing the token.  
            await firebase.database().ref(`businesses/${state.business.id}/fcmTokens/app/${state.fcmToken}`).set(null).then(() => {
                console.log(`cleared fcm token from business ${state.business.name}`);
                return `cleared fcm token from business ${state.business.name}`
            })
        }        
        if(!state.person)
            return
        await firebase.database().ref(`customers/${state.person.uid}/fcmTokens/pwa/businesses/${state.business.id}/${state.fcmToken}`).set(null).then(() => {
            console.log(`cleared fcm token from person for business ${state.business.name}`);
            return `cleared fcm token from person for business ${state.business.name}`
        })            

        return Promise.resolve(true)       
    },

    unRegister: ({ commit, state }) => {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .getRegistrations()
                .then(function (registrations) {
                    registrations.forEach(function (registration) {
                        registration.unregister();
                        console.log("Unregistered.");
                    }, this);

                }).then(() => {
                    //clear any business tokens
                    firebase.database().ref(`businesses/${state.business.id}/fcmTokens/app/${state.fcmToken}`).set(null)
                        .then(() => {
                            console.log("businesses fcm token cleare");
                            return "token sent to server"
                        })
                }).then(() => {
                    if(state.person)
                    {
                        firebase.database().ref(`customers/${state.person.uid}/fcmTokens/pwa/businesses/${state.business.id}/${state.fcmToken}`).set(null).then(() => {
                            console.log("token cleared from user");
                        }).then(() => {
                            return
                        })
                    }
                    return
                }).then(() => {
                    window.location.reload(true);//reload after token cleared.
                });
        }
        else {
            window.location.reload(true);//reload after token cleared.
        }
    },
    setNotifications:({commit,state,dispatch})=>{
        dispatch('setToastMessage',{ type: 'info', message: `Requesting to enable notifications.`, title: 'Notifications' })   
        const messaging = firebase.messaging();
        messaging.requestPermission()
        .then(()=>{        
          // TODO(developer): Retrieve an Instance ID token for use with FCM.
          // ...          
          return messaging.getToken()  
        }).then((token) => {
            
            dispatch('setToastMessage',{ type: 'info', message: `Excellent we have a token for you.`, title: 'Notifications' })                                                   
            
            firebase.database().ref(`customers/${state.person.uid}/fcmTokens/pwa/businesses/${state.business.id}/${token}`).set(moment.utc().unix()).then(() => {
                dispatch('setfcmToken',token)
                dispatch('setToastMessage',{ type: 'info', message: `Now we ask the message center to send you notices only about your current remedials`, title: 'Notifications' })                                                    
            })
            .catch(ex => {
                dispatch('setToastMessage',{ type: 'error', message: `Oh no something went wrong, don't worry just check your remedial manually we just can't message you...`, title: 'Notifications' })
            }); 
            
            if (state.adminrights && state.adminrights.custremedialprocess) {
                //set the token
                firebase.database().ref(`businesses/${state.business.id}/fcmTokens/app/${token}`).set(state.person.id).then(() => {
                    dispatch('setToastMessage',{ type: 'info', message: `Great as a staff member you will receive notifications about person remedials`, title: 'Notifications' })                                                                                           
                })
            }

            messaging.onTokenRefresh(() =>{
                messaging.getToken()
                .then((refreshedToken)=>{
                  dispatch('setToastMessage',{ type: 'info', message: `Notices have been updated with new token.`, title: 'Notifications' })
                  dispatch('setfcmToken',refreshedToken)  
                })
                .catch(function(err) {
                    dispatch('setToastMessage',{ type: 'error', message: `Oh no unable to refresh your notices token.`, title: 'Notifications' })
                });
            });
            // [END refresh_token]
          
            messaging.onMessage((payload)=>{
                console.log(payload.notification);
                dispatch('setToastMessage',{ type: 'info', message:payload.notification.body})            
                // type: 'READY',
                // type: 'STARTED',
                // type: 'SUBMITTED',
                // type: 'DECLINED',
                // type: 'ACCEPTED',      
                // if(['READY','STARTED','SUBMITTED','DECLINED','ACCEPTED'].indexOf(payload.tag) >=0)
                // {
                // dispatch('setToastMessage',{ type: 'info', message:payload.notification.body})            
                // }      
                // this.$toastr("info", payload.notification.body, payload.notification.title);
            })

        })
        .catch((err)=> { 
            if(err.code==='messaging/failed-serviceworker-registration')
            {
                dispatch('setToastMessage',{ type: 'error', message: `Could not enable notifications most likely unable to register.`, title: 'Notifications' })
            }

            if(err.code==='messaging/permission-blocked')
            {
                dispatch('setToastMessage',{ type: 'error', message: `Oh no you blocked notifications, you will need to reset your browser to allow this in the future, see help on how to do this.`, title: 'Notifications' })
            }
            
            console.log(err)
            dispatch('setfcmToken',"errornotoken")                 
        });

        
        
    },
    setCurrentLocation:({commit,state,dispatch})=>{
        dispatch('setToastMessage',{ type: 'info', message: `Great attempting to set location, if ok we will manage things better for you.`, title: 'Locaton' })                           
        navigator.geolocation.watchPosition(
            position => {
                var coords = { latitude: position.coords.latitude, longitude: position.coords.longitude };               
                commit('setLocation',{ coords: coords, latitude: position.coords.latitude, longitude: position.coords.longitude })     
            },
            error => {                      
                switch(error.code) {
                  case error.PERMISSION_DENIED:     
                    dispatch('setToastMessage',{ type: 'error', message: `Cannot sort tiles by location, you denied location request, please remove block from your device to enable it.`, title: 'Locaton Error' })                           
                    break;
                  case error.POSITION_UNAVAILABLE:              
                    dispatch('setToastMessage',{ type: 'error', message: `Location not available.`, title: 'Locaton Error' })                                               
                    break;
                  case error.TIMEOUT:
                    dispatch('setToastMessage',{ type: 'error', message: `Location request timed out.`, title: 'Locaton Error' })                                               
                    break;
                  case error.UNKNOWN_ERROR:
                    dispatch('setToastMessage',{ type: 'error', message: `Unknown Error.`, title: 'Locaton Error' })                                                                  
                    break;
                }
            },
            {
                enableHighAccuracy: false,
                useSignificantChanges: true,
                timeout: 3600000,
                maximumAge: 1800000,
                desiredAccuracy: 0, frequency: 1
            }
          )
    },
    setUpServiceWorker: ({ commit, state }) => {
        
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            deferredPrompt = e;
            commit('enableAddToHomeScreen', true)            
            // Update UI notify the user they can add to home screen            
        });


        const isLocalhost = Boolean(window.location.hostname === 'localhost' ||
            // [::1] is the IPv6 localhost address.
            window.location.hostname === '[::1]' ||
            // 127.0.0.1/8 is considered localhost for IPv4.
            window.location.hostname.match(
                /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
            )
        );
        // console.log("adding service worker")
        if ('serviceWorker' in navigator &&
            (window.location.protocol === 'https:' || isLocalhost)) {
          navigator.serviceWorker.register('service-worker.js')
          .then(function(registration) {
            // updatefound is fired if service-worker.js changes.
            registration.onupdatefound = function() {
              // updatefound is also fired the very first time the SW is installed,
              // and there's no need to prompt for a reload at that point.
              // So check here to see if the page is already controlled,
              // i.e. whether there's an existing service worker.
              if (navigator.serviceWorker.controller) {
                // The updatefound event implies that registration.installing is set
                const installingWorker = registration.installing;
    
                installingWorker.onstatechange = function() {
                  switch (installingWorker.state) {
                    case 'installed':
                      // At this point, the old content will have been purged and the
                      // fresh content will have been added to the cache.
                      // It's the perfect time to display a "New content is
                      // available; please refresh." message in the page's interface.
                      commit('setNewVersionAvailable',true)
                      console.log("new version found")
                      break;
    
                    case 'redundant':
                      throw new Error('Installing the service worker is redundant.');
    
                    default:
                      // Ignore
                  }
                };
              }
            };
          }).catch(function(e) {
            console.error('Error during service worker registration:', e);
          });
        }
    }

}


// var setLocalStorage = (user) => {
//     if (window.localStorage) {
//         localStorage.setItem('uid', user.uid);
//         localStorage.setItem('id', user.id);
//         localStorage.setItem('email', user.email);
//         localStorage.setItem('displayName', user.displayName);
//         localStorage.setItem('name', user.name);
//         localStorage.setItem('token', user.token);
//         localStorage.setItem('photo', user.photo);
//     }
// }







export default new Vuex.Store({
    // strict: true,    
    modules: {
        // specialsModule:specialsModule
        // ,
        // foo: {
        //     namespaced: true,
      
        //     actions: {
        //       someAction: {
        //         root: true,
        //         handler (namespacedContext, payload) { 

        //         } // -> 'someAction'
        //       }
        //     }
        //   }
    },    
    plugins: [createLogger()],
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
})


// WEBPACK FOOTER //
// ./src/store/store.js